import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
import { CommodityStatusCode } from '@bechtel/types';

export const WeldActionStyled = styled(Box).attrs({
  pl: { sm: '550' },
  pr: { sm: '500' },
  py: { sm: '500' },
})`
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px, rgb(0 0 0 / 12%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px;
`;

export const WeldTimePeriodStyled = styled(Box).attrs({
  mr: { sm: '400' },
})`
  ${({ theme }) => css`
    align-items: center;
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.black[100]};
  `}
`;

export const WeldChipContainerStyled = styled(Box).attrs({
  mr: { sm: '450' },
})`
  ${({ theme }) => css`
    border-radius: ${theme.radii[800]};

    ${getBackgroundStatusColor};
  `}
`;

interface WeldStatusProps {
  status?: CommodityStatusCode;
}
const getBackgroundStatusColor = (props: WeldStatusProps) => {
  switch (props.status) {
    case CommodityStatusCode.VT_APPROVED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
      `;
    case CommodityStatusCode.CLAIMED:
    case CommodityStatusCode.FITUP_INSPECTION:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[500]};
      `;
    case CommodityStatusCode.BLOCKED:
      return css`
        background-color: ${({ theme }) => theme.colors.red[500]};
      `;
    case CommodityStatusCode.VT_SENT_BACK:
    case CommodityStatusCode.SENT_BACK_TO_PIPING:
      return css`
        background-color: ${({ theme }) => theme.colors.purple[500]};
      `;
    case CommodityStatusCode.READY_TO_WELD:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
      `;
    case CommodityStatusCode.FITUP_REQUESTED:
      return css`
        background-color: ${({ theme }) => theme.colors.yellow[300]};
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
      `;
  }
};
